const FLAG_STATUSES = {
  PENDING: 0,
  UNDERSTOOD: 1,
  DID_NOT_UNDERSTAND: 2,
};

export default FLAG_STATUSES;
